import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { emsCompetition, emsTeam, emsVeto, emsVetoAction, emsVetoPool } from 'src/models/emsModels';
import { NotificationBar } from 'src/services/notification.service';
import { environment } from 'src/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogDialog } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-veto',
  templateUrl: './veto.component.html',
  styleUrl: './veto.component.scss'
})
export class VetoComponent {

  notificationBar: NotificationBar;
  vetoGroup = new FormGroup({
    lobbyCodeControl: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
  });
  isLoading = false;
  veto = new emsVeto();
  vetoListenerRef: any;
  stayUpdatedIntervalID: any;
  userSelected = false;
  roleName = "";
  roleConnected = "";
  lastPoolItemName = "";
  stayUpdatedInterval = 1000;
  competition = new emsCompetition();
  teamOne = new emsTeam();
  teamTwo = new emsTeam();
  vetoDBRef: any;
  competitionDBRef: any;
  teamOneDBRef: any;
  teamTwoDBRef: any;

  constructor(private router: Router, private route: ActivatedRoute, private title: Title, private location: Location, private snackBar: MatSnackBar, private db: AngularFireDatabase, public dialog: MatDialog) {
    this.notificationBar = new NotificationBar(snackBar);
  }

  ngOnInit() {
    this.title.setTitle("Veto - EsportsMS");
    var lobbyCode = this.route.snapshot.queryParamMap.get('lobby');
    if (lobbyCode) {
      this.joinVeto(lobbyCode);
    };
  }

  ngOnDestroy() {
    if (this.vetoDBRef) {
      this.vetoDBRef.off('value');
    };
    if (this.competitionDBRef) {
      this.competitionDBRef.off('value');
    };
    if (this.teamOneDBRef) {
      this.teamOneDBRef.off('value');
    };
    if (this.teamTwoDBRef) {
      this.teamTwoDBRef.off('value');
    };
    if (this.vetoListenerRef) {
      this.vetoListenerRef.off('value');
    };
  }

  async joinVeto(lobbyCode?: string) {
    if (lobbyCode) {
      this.vetoGroup.controls.lobbyCodeControl.setValue(lobbyCode);
    }
    this.isLoading = true;
    var tempVetosDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies').orderByChild('lobbyCode').equalTo(this.vetoGroup.controls.lobbyCodeControl.value.toLocaleUpperCase());
    await tempVetosDBRef.once('value').then( x => {
      var lobbyUID = "";
      x.forEach( x => {
        var veto = x.toJSON() as emsVeto;
        try {
          if (veto.lobbyCode.toUpperCase() == this.vetoGroup.controls.lobbyCodeControl.value.toLocaleUpperCase()) {
            lobbyUID = x.key;
          }
        } catch { }        
      })
      if (lobbyUID) {
        this.setLobbyCodeURLParam(this.vetoGroup.controls.lobbyCodeControl.value.toLocaleUpperCase());
        this.vetoDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + lobbyUID);
        this.vetoListenerRef = this.vetoDBRef;
        var firstSync = true;
        this.vetoDBRef.on('value', x => {
          var vetoData = x.toJSON() as emsVeto;
          vetoData.uid = x.key;
          this.loadTeams(vetoData.teamOne, vetoData.teamTwo);
          this.loadCompetition(vetoData.competition);          
          if (vetoData.pool) {
            vetoData.pool = Object.values(vetoData.pool);
          } else {
            vetoData.pool = [];
          }
          if (vetoData.actions) {
            vetoData.actions = Object.values(vetoData.actions);
          } else {
            vetoData.actions = [];
          }
          this.veto = vetoData;
          if (firstSync == true) {
            firstSync = false;
            this.isLoading = false;
            this.vetoGroup.controls.lobbyCodeControl.setValue("");
          }
        });
        this.stayUpdated();
      }
      else {
        this.notificationBar.show("Lobby not found!")
        this.setLobbyCodeURLParam(null);
        this.isLoading = false;
        this.vetoGroup.reset();
        this.vetoGroup.controls.lobbyCodeControl.setErrors(null);
      }
    })
  }

  setLobbyCodeURLParam(lobbyCode: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { lobby: lobbyCode },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  loadCompetition(competitionID: string) {
    this.competitionDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/competitions/' + competitionID);
    this.competitionDBRef.on('value', x => {
      this.competition = x.toJSON() as emsCompetition;
    });
  }

  loadTeams(teamOneID: string, teamTwoID: string) {
    this.teamOneDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/teams/' + teamOneID);
    this.teamOneDBRef.on('value', x => {
      this.teamOne = x.toJSON() as emsTeam;
    });
    this.teamTwoDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/teams/' + teamTwoID);
    this.teamTwoDBRef.on('value', x => {
      this.teamTwo = x.toJSON() as emsTeam;
    });
  }

  stayUpdated() {
    if (this.stayUpdatedIntervalID) return;
    this.stayUpdatedIntervalID = setInterval(async () => {
      this.vetoListenerRef.child('workspace').get()
      if (this.veto.actions.length <= this.veto.currentAction) {
        var timestamp = new Date().toISOString();
        var concludedSnap = await this.vetoListenerRef.child('concluded').get();
        if (!concludedSnap.val()) {
          this.vetoListenerRef.child('concluded').set(timestamp)
          this.vetoListenerRef.child('lobbyCode').set("")
        }
      }
    }, this.stayUpdatedInterval);
  }

  leaveVeto() {
    this.vetoListenerRef.off('value');
    if (this.vetoDBRef) {
      this.vetoDBRef.off('value');
    };
    if (this.competitionDBRef) {
      this.competitionDBRef.off('value');
    };
    if (this.teamOneDBRef) {
      this.teamOneDBRef.off('value');
    };
    if (this.teamTwoDBRef) {
      this.teamTwoDBRef.off('value');
    };
    var vetoRoleRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/' + this.roleConnected);
    vetoRoleRef.set(false);
    clearInterval(this.stayUpdatedIntervalID);
    this.stayUpdatedIntervalID = null;
    this.veto = new emsVeto();
    this.roleName = "";
    this.roleConnected = "";
    this.vetoGroup.reset();
    this.vetoGroup.controls.lobbyCodeControl.setErrors(null);
    this.setLobbyCodeURLParam(null);
    this.notificationBar.show("Disconnected!")
  }

  getExecutorName() {
    var executor = this.veto.actions[this.veto.currentAction].executor;
    if (executor == 'teamA' && this.veto.teamA) {
      return this.veto.teamA;
    }
    else if (executor == 'teamB' && this.veto.teamB) {
      return this.veto.teamB;
    }
    else if (executor == 'startingTeam' && this.veto.startingTeam) {
      return this.veto.startingTeam;
    }
    else if (executor == 'admin') {
      return "Admin";
    }
    else if (executor == 'system') {
      return "System";
    } 
    else {
      return executor;
    }
  }

  transformExecutorName(executor: string) {
    if (executor == 'teamA' && this.veto.teamA) {
      return this.veto.teamA;
    }
    else if (executor == 'teamA') {
      return "Team A";
    }
    else if (executor == 'teamB' && this.veto.teamB) {
      return this.veto.teamB;
    }
    else if (executor == 'teamB') {
      return "Team B";
    }
    else if (executor == 'startingTeam' && this.veto.startingTeam) {
      return this.veto.startingTeam;
    }
    else if (executor == 'startingTeam') {
      return "TBD";
    }
    else if (executor == 'admin') {
      return "Admin";
    } 
    else if (executor == 'system') {
      return "";
    } 
    else {
      return executor;
    }
  }

  selectAdminRole() {
    if (this.veto.adminConnected == false || !this.veto.adminConnected) {
      this.vetoListenerRef.onDisconnect().update({ adminConnected: false });
      this.vetoListenerRef.update({
        adminConnected: true,
      });
      this.roleName = "Admin";
      this.roleConnected = "adminConnected";
      this.notificationBar.show("Connected as Admin!")
    }
    else {
      this.notificationBar.show("Admin is already connected!")
    }
  }

  selectTeamOneRole() {
    if (this.veto.teamOneConnected == false || !this.veto.teamOneConnected) { 
      this.vetoListenerRef.onDisconnect().update({ teamOneConnected: false });
      this.vetoListenerRef.update({
        teamOneConnected: true,
      });
      this.roleName = this.teamOne.tricode;
      this.roleConnected = "teamOneConnected";
      this.notificationBar.show("Connected as " + this.teamOne.tricode + "!")
    }
    else {
      this.notificationBar.show(this.teamOne.tricode + " is already connected!")
    }
  }

  selectTeamTwoRole() {
    if (this.veto.teamTwoConnected == false || !this.veto.teamTwoConnected) { 
      this.vetoListenerRef.onDisconnect().update({ teamTwoConnected: false });
      this.vetoListenerRef.update({
        teamTwoConnected: true,
      });
      this.roleName = this.teamTwo.tricode;
      this.roleConnected = "teamTwoConnected";
      this.notificationBar.show("Connected as " + this.teamTwo.tricode + "!")
    }
    else {
      this.notificationBar.show(this.teamTwo.tricode + " is already connected!")
    }
  }

  async selectStartingTeam(teamName: string) {
    var dialogRef = this.dialog.open(ConfirmDialogDialog, {
      data: {
        actionType: "confirm",
        message: "Starting - " + teamName,
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    if (res == true) {
      var vetoActionRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/actions/' + this.veto.currentAction);
      vetoActionRef.child('log').set(teamName);
      var nextAction = this.veto.currentAction + 1;
      this.vetoListenerRef.update({
        startingTeam: teamName,
        currentAction: nextAction
      });
    }
  }

  async selectTeamAB(ownTeamName: string, selectedTeam: string) {
    var tempTeamOne = "";
    var tempTeamTwo = "";
    if (ownTeamName == this.teamOne.tricode) {
      tempTeamOne = this.teamOne.tricode;
      tempTeamTwo = this.teamTwo.tricode;
    }
    else {
      tempTeamOne = this.teamTwo.tricode;
      tempTeamTwo = this.teamOne.tricode;
    }
    var dialogRef = this.dialog.open(ConfirmDialogDialog, {
      data: {
        actionType: "confirm",
        message: "Team Selection - " + selectedTeam,
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    if (res == true) {
      var vetoActionRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/actions/' + this.veto.currentAction);
      vetoActionRef.child('log').set(selectedTeam);
      var nextAction = this.veto.currentAction + 1;
      if (selectedTeam == "A") {
        this.vetoListenerRef.update({
          teamA: tempTeamOne,
          teamB: tempTeamTwo,
          currentAction: nextAction
        });
      }
      else {
        this.vetoListenerRef.update({
          teamA: tempTeamTwo,
          teamB: tempTeamOne,
          currentAction: nextAction
        });
      }
    }
  }

  async selectFromPool(poolIndex: number, poolName: string) {
    if (this.veto.actions[this.veto.currentAction].type == 'ban') {
      var dialogRef = this.dialog.open(ConfirmDialogDialog, {
        data: {
          actionType: "confirm",
          message: "Ban - " + poolName,
        }
      });
    }
    else {
      var dialogRef = this.dialog.open(ConfirmDialogDialog, {
        data: {
          actionType: "confirm",
          message: "Pick - " + poolName,
        }
      });
    }    
    const res = await dialogRef.afterClosed().toPromise();
    if (res == true) {
      var vetoActionRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/actions/' + this.veto.currentAction);
      vetoActionRef.child('log').set(poolName);
      var vetoPoolRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/pool/' + poolIndex);
      vetoPoolRef.child('available').set(false);
      var nextAction = this.veto.currentAction + 1;
      this.vetoListenerRef.update({
          currentAction: nextAction
      });
      this.checkIfNextActionIsDecider();
    }
  }

  async selectSide(side: string) {
    var dialogRef = this.dialog.open(ConfirmDialogDialog, {
      data: {
        actionType: "confirm",
        message: "Side - " + side,
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    if (res == true) {
      var vetoActionRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/actions/' + this.veto.currentAction);
      vetoActionRef.child('log').set(side);
      var nextAction = this.veto.currentAction + 1;
      this.vetoListenerRef.update({
          currentAction: nextAction
      });
      this.checkIfNextActionIsDecider();
    }
  }

  lastPoolLeft() {
    const remainingAmount = this.veto.pool.filter(p => p.available == true).length;
    if (remainingAmount == 1) {
      this.lastPoolItemName = this.veto.pool.find(x => x.available == true).name;
      return true;
    }
    else {
      this.lastPoolItemName = "";
      return false
    }
  }

  checkIfNextActionIsDecider() {
    if (this.lastPoolLeft() && this.veto.actions[this.veto.currentAction].executor == "system") {
      var vetoActionRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/actions/' + this.veto.currentAction);
      vetoActionRef.child('log').set(this.lastPoolItemName);
      var nextAction = this.veto.currentAction + 1;
      this.vetoListenerRef.update({
        currentAction: nextAction
      });
    }
  }

  async undoLastAction() {
    var dialogRef = this.dialog.open(ConfirmDialogDialog, {
      data: {
        actionType: "confirm",
        message: "Are you sure you want to undo the last action?",
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    if (res == true) {
      var lastAction = this.veto.currentAction - 1;
      var tempVetoActionRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/actions/' + lastAction);
      await tempVetoActionRef.once('value', async x => {
        var action = x.toJSON() as emsVetoAction;
        if (action.type == "ban" || action.type == "pick") {
          var tempVetoPoolDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/pool')
          await tempVetoPoolDBRef.once('value', x => {
            x.forEach(pool => {  
              var poolInfo = pool.toJSON() as emsVetoPool;
              if (poolInfo.name == action.log) {
                tempVetoPoolDBRef.child(pool.key + '/available').set(true);
              }
            });
          });
        }
        else if (action.type == "selectTeamAB") {
          this.vetoListenerRef.update({
            teamA: null,
            teamB: null,
          });
        }
        else if (action.type == "selectStartingTeam") {
          this.vetoListenerRef.update({
            startingTeam: null,
          });
        }
        else if (action.type == "decider") {
          lastAction = lastAction - 1; // going even one more step back to get system action
          var tempVetoSystemActionRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/actions/' + lastAction);
          await tempVetoSystemActionRef.once('value', async x => { 
            var systemAction = x.toJSON() as emsVetoAction;
            var tempVetoPoolDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + this.veto.uid + '/pool')
            await tempVetoPoolDBRef.once('value', x => {
            x.forEach(pool => {  
              var poolInfo = pool.toJSON() as emsVetoPool;
              if (poolInfo.name == systemAction.log) {
                tempVetoPoolDBRef.child(pool.key + '/available').set(true);
              }
            });
            tempVetoSystemActionRef.child('log').set("");
          });
          })
        }
        tempVetoActionRef.child('log').set("");
        this.vetoListenerRef.update({
          currentAction: lastAction
        });
      });
    }    
  }
}
